import { IErrorResponseDto } from "../dtos/error-response.dto";
import { normalizeApiError } from "../utils/normalize-api-error";

export async function readErrorResponse(response: Response): Promise<IErrorResponseDto> {
  let body: unknown;

  try {
    body = await response.clone().json();
  } catch {
    try {
      body = await response.text();
    } catch {
      body = undefined;
    }
  }

  return normalizeApiError({
    status: response.status,
    statusText: response.statusText,
    data: body,
  });
}
